import Axios from 'axios'
import Qs from 'qs'
import router from '../../router'
import { Message } from 'element-ui'

const request = Axios.create({
  timeout: 10000,
  timeoutErrorMessage: '请求超时，请稍候重试',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
})

//请求拦截  
request.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem('token')
  // let browserId = window.localStorage.getItem('browserId')
  // config.headers['projectSource'] = 'dyy-pc'
  if (config.jsonData) {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.data = JSON.stringify(config.jsonData)
  } else if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8'
  } else {
    config.data = Qs.stringify(config.data)
  }

  if (token) {
    config.headers['token'] = token
  }
  //请求头 浏览器指纹参数
  config.headers['browserId'] = 'Host by MidOffice'
  return config
}, function (error) {
  console.error(error)
  return Promise.reject(error)
})

const DEFAULT_ERROR_MSG = '出现错误，请稍候重试'

// 添加一个响应拦截器
request.interceptors.response.use(function (response) {
  if (response.data) {
    if (response.data instanceof Blob) {
      if (response.data.type.includes('application/json')) {
        // 返回文件
        return response
      }
      // 出现错误，返回json字符串
      response.data.text().then(text => {
        const data = JSON.parse(text)
        let msg = data.data || data.message
        msg = data.msg === 'null' ? DEFAULT_ERROR_MSG : data.msg || DEFAULT_ERROR_MSG
        Message({
          message: msg,
          type: 'error'
        })
      }).catch(_error => {
        Message({
          message: DEFAULT_ERROR_MSG,
          type: 'error'
        })
      })
      return Promise.reject('error')
    }
    if (response.data.code === '200') {
      // 请求成功
      return response.data
    }
    if (response.data.code === '401') {
      // 未登录
      router.replace({ path: '/login' })
      return
    }

    let msg = response.data.data || response.data.message
    msg = msg === 'null' ? DEFAULT_ERROR_MSG : msg || DEFAULT_ERROR_MSG
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject('error')
  }
  Message({
    message: DEFAULT_ERROR_MSG,
    type: 'error'
  })
  return Promise.reject('error')
}, function (error) {
  console.error(error, error.response)
  let msg
  if (error.code === 'ECONNABORTED') {
    msg = '请求超时，请稍候重试'
  } else if (error.response && error.response.status !== 200) {
    if (error.response.data) {
      if (error.response.data.code === '401') {
        // 未登录
        router.replace({ path: '/login' })
        return
      }
      msg = error.response.data.data || error.response.data.message || DEFAULT_ERROR_MSG
    } else {
      msg = error.message
    }
  }
  if (msg) {
    Message({
      message: msg,
      type: 'error'
    })
  }
  return Promise.reject(error)
})

export default request



// WEBPACK FOOTER //
// ./src/assets/js/jbbDataRequest.js